import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import NumericInput from "react-numeric-input";
import "rc-time-picker/assets/index.css";
import WeekDayCheckboxes from "../../CommonComponents/WeekDayCheckboxes";

const ParkhauspreisabweichungenEdit = (props) => {
  const { t } = useTranslation();
  const link = "/api/CustomLogic";

  let newEntry = props.data == null;
  const [data, setData] = useState(props.data ?? {});
  const [weekdays, setWeekdays] = useState(props.data?.wochentage ?? []);

  const [failShow, setFailShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function handleValidSubmit() {
    data.wochentage = weekdays;

    setFailShow(false);
    axios({
      method: newEntry ? "post" : "put",
      url: link + "/Preise/Parkhauspreisabweichung",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        props.onChange();
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(error.message);
        setFailShow(true);
      });
  }

  return (
    <div id="pop-up-settings" style={{ height: 400 }}>
      <SimpleBar style={{ height: "100%" }}>
        <div className="box-name">
          Parkhauspreisabweichung {newEntry ? "anlegen" : "bearbeiten"}
        </div>
        <AvForm
          className="form-horizontal"
          onValidSubmit={() => {
            handleValidSubmit();
          }}
          style={{ opacity: "1" }}
        >
          {props.error && props.error ? (
            <Alert color="danger">{props.error}</Alert>
          ) : null}
          <div style={{ width: "90%", margin: "auto" }}>
            <div style={{ marginTop: "20px" }}>
              <div className="content-group-name">Parkhausname</div>
              <AvField
                style={{ height: "25px" }}
                value={data?.parkhausname}
                className="form-control"
                name="parkhausname"
                required
                onChange={(e) => {
                  data.parkhausname = e.target.value;
                  setData(data);
                }}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <div className="content-group-name">Wochentage</div>
              <WeekDayCheckboxes
                selectedWeekdays={data.wochentage}
                setWeekdays={setWeekdays}
              ></WeekDayCheckboxes>
            </div>

            <div style={{ marginTop: "20px" }}>
              <div className="content-group-name">Preis pro Tag</div>
              <AvField
                style={{ height: "25px" }}
                value={data?.preisProTag?.toString()?.replace(".", ",")}
                className="form-control"
                name="preisProTag"
                required
                onChange={(e) => {
                  data.preisProTag = e.target.value.replace(",", ".");
                  setData(data);
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <button type="submit" className="button">
                {t("allgemein.speichern")}
              </button>
            </div>
            {failShow == true && (
              <div className="login-fail">{errorMessage}</div>
            )}
          </div>
        </AvForm>
      </SimpleBar>
    </div>
  );
};

export default ParkhauspreisabweichungenEdit;
